import * as React from "react";
import { useApprovalExecution, UseApprovalExecutionProps } from "./hooks/useApprovalExecution";

/**
 * Headless component for executing approval transfers with event-driven communication.
 * Automatically executes approval transactions when mounted and reports progress/completion back to .NET.
 */
const ApprovalExecutor: React.FC<UseApprovalExecutionProps> = (props) => {
    // This hook handles all approval execution logic and event emission
    useApprovalExecution(props);

    // This component is headless and renders no UI
    return null;
};

export default ApprovalExecutor;

